import Highcharts from 'highcharts/highstock'

let hasBeenInitialized = false

function initHighcharts () {
  if (!hasBeenInitialized) {
    Highcharts.setOptions({
      lang: {
        decimalPoint: '.',
        thousandsSep: ','
      }
    });
    hasBeenInitialized = true
  }
}

export default initHighcharts